export default "__VITE_ASSET__b8e7eca3__"